import { createStyles, Theme } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      height: '100%',
      padding: spacing(4),
      position: 'relative',
    },
    tile: {
      backgroundColor: '#F7F8FA', // TODO replace after creating new palette
      borderRadius: 8,
      padding: spacing(6, 6, 8, 6),
      width: '100%',

      '&:not(:last-child)': {
        marginBottom: spacing(4),
      },
    },
    tileHeading: {
      color: colors.black.darker,
      fontSize: 16,
      fontWeight: 600,
      lineHeight: '24px',
      marginBottom: spacing(1),
    },
    tileDescription: {
      color: '#515D70', // TODO change after creating new palette
      fontSize: 14,
      fontWeight: 500,
      lineHeight: '20px',
      marginBottom: spacing(4),
    },
    building: {
      backgroundColor: colors.white.lightest,
      border: '1px solid #EAECF0', // TODO change after creating new palette
      borderRadius: 6,
      boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
      padding: spacing(4),
      width: '100%',

      '&:not(:last-child)': {
        marginBottom: spacing(4),
      },
    },
    buildingSelectable: {
      '&:hover': {
        borderColor: '#9EA6B3', // TODO change after creating new palette
        cursor: 'pointer',
      },
    },
    buildingSelected: {
      borderColor: colors.kato.navy[900],

      '& $buildingButton': {
        borderColor: colors.kato.navy[900],
      },
    },
    buildingButton: {},
    buildingCheckIcon: {
      marginRight: spacing(1),
    },
    infoLabel: {
      color: '#7E8899', // TODO change after creating new palette
      fontSize: 14,
      fontWeight: 500,
      minWidth: 130,
    },
    infoValue: {
      color: colors.black.darker,
      fontSize: 14,
      fontWeight: 500,
    },
  });
